<div class="map-wrapper">
  
  <div class="map-title-overlay">
    <h2>Sales Team Distribution</h2>
    <p>Live global workspace node layout parameters</p>
    
    <div class="toggle-control-group">
      <label class="custom-toggle">
        <input type="checkbox" [ngModel]="showMarkers()" (ngModelChange)="showMarkers.set($event)">
        <span class="slider"></span>
        <span class="label-text">Show Individual Nodes (Dots)</span>
      </label>
      
      <label class="custom-toggle">
        <input type="checkbox" [ngModel]="showHeatmap()" (ngModelChange)="showHeatmap.set($event)">
        <span class="slider"></span>
        <span class="label-text">Enable Density Heatmap</span>
      </label>
    </div>
  </div>

  <google-map 
    height="100%" 
    width="100%" 
    [options]="mapOptions"
    (mapInitialized)="onMapInitialized()">
    
    @if (showMarkers()) {
      @for (agent of geocodedAgents(); track agent.id) {
        <map-marker
          #markerElem="mapMarker" [position]="agent.position"
          [title]="agent.firstName + ' ' + agent.lastName"
          [options]="getMarkerOptions(agent)"
          (mapClick)="onMarkerClick(markerElem, agent)" />
      }
    }

    <map-info-window>
      @if (selectedAgent(); as agent) {
        <div class="agent-info-card">
          <span class="region-badge">Sales Agent {{ agent.id }}</span>
          <h3>{{ agent.firstName }} {{ agent.lastName }}</h3>
          <p class="email-text">{{ agent.city }}, {{ agent.state }}</p>
          <p class="email-text" *ngIf="agent.email">{{ agent.email }}</p>
          <p class="email-text" *ngIf="agent.phoneNumber">{{ agent.phoneNumber | phone }}</p>
          <div class="footer-row" *ngIf="agent.email">
            <a [href]="'mailto:' + agent.email" class="contact-btn">
              Connect Directly
            </a>
          </div>
        </div>
      }
    </map-info-window>
    
  </google-map>
</div>